import { useEffect, useState } from 'react';
import { Modal, Badge } from 'react-bootstrap';

import FormEmissao from '../componentsPage/FormEmissao';




const ModalEmissao = (props: any) => {



    const [show, setShow] = useState(props.show)
    const [endossado, setEndossado] = useState<boolean>(false)


    useEffect(() => {

        
        setShow(props.show);
        
    }, [props.show, props.usuario_id, props.now]);



    return (

        <div>

            <Modal
                
                //show={show}
                //fullscreen={true}
                //onHide={() => setShow(false)}
                //style={{ height: "auto" }}
                size="xl"
                show={show}
                onHide={() => setShow(false)}
                aria-labelledby="example-modal-sizes-title-xl"
                >
                <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-xl">

                    
                        Emissão {props.pin} { endossado ? (<Badge bg='info'>Endossado</Badge>) : null }



                </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                            
                    
                    <FormEmissao setEmissao_id={props.setEmissao_id} setEndossado={setEndossado} pin={props.pin} setPin={props.setPin} 
                    cliente_id={props.cliente_id} emissao_id={props.emissao_id} setShow={props.setShow} now={props.now} carregaEmissoes={props.carregaEmissoes} />
                     
                    
                            


                </Modal.Body>
               

            </Modal>

        </div>

    )
}

export default ModalEmissao